import { resolveTabIn, searchWithTabFor } from '../../util_components/page_tabs/page_tabs';
import type { TabDef as GenericTabDef } from '../../util_components/page_tabs/page_tabs';

export type PageTab = 'tasks' | 'generation' | 'report';

export type TabDef = GenericTabDef<PageTab>;

export const DEFAULT_TAB: PageTab = 'tasks';

const ALL_TABS: TabDef[] = [
  { id: 'tasks', label: 'Tasks' },
  { id: 'generation', label: 'Task generation' },
  { id: 'report', label: 'Instant task report' }
];

// The report tab is SUPER_USER-only, so it is absent (not disabled) otherwise.
export const tabList = (canViewReport: boolean): TabDef[] =>
  ALL_TABS.filter((t) => t.id !== 'report' || canViewReport);

export const resolveTab = (search: string | URLSearchParams, canViewReport: boolean): PageTab =>
  resolveTabIn(tabList(canViewReport), DEFAULT_TAB, search);

export const searchWithTab = (search: string | URLSearchParams, tab: PageTab): string =>
  searchWithTabFor(DEFAULT_TAB, search, tab);
